import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Swiftdzireonrentinnavimumbai() {



  const cardData = {
    keyword: " Swift Dzire on Rent in Navi Mumbai  ",


"headingDescription": "Royal Route Cab offers reliable Swift Dzire on rent in Navi Mumbai, providing comfortable, affordable, and efficient travel solutions for local rides, airport transfers, corporate travel, and outstation journeys. Maruti Swift Dzire is one of the most popular sedan cars known for its excellent mileage, smooth performance, and comfortable seating, making it ideal for both city and long-distance travel. Whether you need a daily commute ride, airport pickup, or a long highway trip, our well-maintained Swift Dzire ensures a stress-free and budget-friendly journey. With professional drivers, clean interiors, and flexible booking options like one-way, round trip, and full-day rental, Royal Route Cab is a trusted choice for Swift Dzire rental in Navi Mumbai. Pricing is economical, typically starting around ₹11–₹12 per km, making it a preferred sedan option for budget travelers. :contentReference[oaicite:0]{index=0}",

"topPlaces": [
  {
    "title": "Swift Dzire on Rent in Navi Mumbai",
    "description": "Swift Dzire on rent in Navi Mumbai is a popular and budget-friendly cab option for daily travel, airport transfers, and short city rides. It offers good comfort, fuel efficiency, and smooth performance for solo travelers and small families."
  },
  {
    "title": "Navi Mumbai Swift Dzire Rental Service",
    "description": "Swift Dzire rental service in Navi Mumbai provides reliable and economical transportation for local travel, office commutes, family trips, and business meetings with professional drivers."
  },
  {
    "title": "Swift Dzire with Driver Navi Mumbai",
    "description": "Swift Dzire with driver service in Navi Mumbai ensures a hassle-free travel experience with trained chauffeurs, making it ideal for city travel, airport drops, and daily commuting."
  },
  {
    "title": "Airport Swift Dzire Cab Navi Mumbai",
    "description": "Airport Swift Dzire cab service in Navi Mumbai is widely used for pickup and drop services. It offers timely service, comfortable seating, and a smooth ride for passengers traveling to and from the airport."
  },
  {
    "title": "Affordable Swift Dzire Rental Navi Mumbai",
    "description": "Affordable Swift Dzire rental in Navi Mumbai is a cost-effective transportation option for passengers looking for comfort and reliability at budget-friendly prices."
  },
  {
    "title": "Swift Dzire for Local Travel Navi Mumbai",
    "description": "Swift Dzire is ideal for local travel in Navi Mumbai, offering a smooth and comfortable ride for office trips, shopping, and daily commuting needs."
  },
  {
    "title": "Swift Dzire for Outstation Navi Mumbai",
    "description": "Swift Dzire is commonly used for outstation travel from Navi Mumbai to nearby destinations like Pune, Lonavala, Nashik, and Shirdi, ensuring a comfortable and economical journey."
  },
  {
    "title": "Corporate Swift Dzire Cab Navi Mumbai",
    "description": "Corporate Swift Dzire cab service in Navi Mumbai is preferred by business travelers for meetings, office travel, and airport transfers, offering punctual and reliable service."
  },
  {
    "title": "Economy Swift Dzire Cab Service Navi Mumbai",
    "description": "Economy Swift Dzire cab service in Navi Mumbai provides affordable transportation with basic comfort and safety, making it ideal for regular commuters and budget travelers."
  },
  {
    "title": "One Way Swift Dzire Cab Navi Mumbai",
    "description": "One way Swift Dzire cab service in Navi Mumbai is suitable for point-to-point travel, offering convenient and cost-effective rides for airport and intercity journeys."
  }
],






services: [
  {
    name: "Swift Dzire on Rent in Mumbai",
    description: "Swift Dzire on rent in Mumbai offers affordable and comfortable travel for city rides, airport transfers, and outstation trips. Ideal for individuals and small families, this sedan ensures smooth driving and good mileage. Professional drivers enhance safety. It guarantees a convenient and budget-friendly journey."
  },
  {
    name: "Swift Dzire on Rent in Navi Mumbai",
    description: "Swift Dzire on rent in Navi Mumbai provides economical travel with comfortable seating and reliable performance. Perfect for local commuting and short trips. Clean vehicles and trained drivers ensure comfort. It guarantees a smooth ride."
  },
  {
    name: "Swift Dzire Rental Navi Mumbai",
    description: "Swift Dzire rental Navi Mumbai offers flexible options for hourly, daily, and outstation travel. Customers can choose plans based on their needs. Affordable pricing makes it ideal for budget travel. It ensures reliable transportation."
  },
  {
    name: "Swift Dzire Hire in Navi Mumbai",
    description: "Swift Dzire hire in Navi Mumbai provides convenient and cost-effective travel solutions for personal and business use. Ideal for city travel and short-distance trips. Professional drivers ensure safety. It guarantees a comfortable journey."
  },
  {
    name: "Swift Dzire Car Rental Navi Mumbai",
    description: "Swift Dzire car rental Navi Mumbai offers a practical and economical option for daily travel. Known for fuel efficiency and comfort, it is suitable for all travel needs. Flexible booking options enhance convenience. It ensures a smooth experience."
  },
  {
    name: "Swift Dzire Taxi Service Navi Mumbai",
    description: "Swift Dzire taxi service Navi Mumbai ensures dependable transportation with comfortable vehicles and experienced drivers. Ideal for local travel, airport transfers, and outstation trips. It guarantees a reliable journey."
  },
  {
    name: "Book Swift Dzire on Rent in Navi Mumbai",
    description: "Book Swift Dzire on rent in Navi Mumbai with easy online booking and instant confirmation. Customers can select pickup location, timing, and travel plan. Transparent pricing ensures trust. It simplifies travel planning."
  },
  {
    name: "Best Swift Dzire on Rent Navi Mumbai",
    description: "Best Swift Dzire on rent Navi Mumbai ensures quality vehicles, professional drivers, and excellent service. This service focuses on comfort, safety, and punctuality. It guarantees a premium yet affordable travel experience."
  },
  {
    name: "Cheapest Swift Dzire Rental Navi Mumbai",
    description: "Cheapest Swift Dzire rental Navi Mumbai offers budget-friendly travel options without compromising comfort. Transparent pricing ensures no hidden charges. Ideal for cost-conscious travelers. It ensures economical travel."
  },
  {
    name: "Swift Dzire on Rent with Driver Navi Mumbai",
    description: "Swift Dzire on rent with driver Navi Mumbai provides stress-free travel with experienced chauffeurs. Ideal for city rides and long trips. Customers can enjoy comfortable rides without driving hassles. It ensures convenience and safety."
  },
  {
    name: "Swift Dzire Rental Service Navi Mumbai",
    description: "Swift Dzire rental service Navi Mumbai offers dependable travel solutions for local and outstation journeys. Well-maintained vehicles and trained drivers ensure comfort. It guarantees reliable service."
  },
  {
    name: "Swift Dzire Airport Pickup Navi Mumbai",
    description: "Swift Dzire airport pickup Navi Mumbai provides seamless pickup services from airport terminals. Comfortable interiors make it ideal for quick transfers. Professional drivers ensure timely service. It guarantees a smooth journey."
  },
  {
    name: "Swift Dzire Airport Drop Navi Mumbai",
    description: "Swift Dzire airport drop Navi Mumbai ensures timely transportation to the airport for departures. Comfortable vehicles enhance travel convenience. Ideal for individuals and small families. It guarantees stress-free travel."
  },
  {
    name: "Swift Dzire Outstation Rental Navi Mumbai",
    description: "Swift Dzire outstation rental Navi Mumbai is perfect for long-distance travel with excellent mileage and comfort. Ideal for business trips and family travel. Professional drivers ensure safety. It guarantees a smooth journey."
  },
  {
    name: "Swift Dzire Cab for Outstation Navi Mumbai",
    description: "Swift Dzire cab for outstation Navi Mumbai offers affordable travel for intercity trips. Ideal for individuals and small groups. Clean vehicles and experienced drivers ensure comfort. It guarantees a pleasant experience."
  },
  {
    name: "Swift Dzire on Rent in Vashi",
    description: "Swift Dzire on rent in Vashi provides economical and reliable travel for residents and professionals. Ideal for local commuting and airport transfers. It ensures a smooth ride."
  },
  {
    name: "Swift Dzire on Rent in Nerul",
    description: "Swift Dzire on rent in Nerul offers comfortable and affordable travel for city rides and short trips. Clean vehicles enhance comfort. It ensures a reliable journey."
  },
  {
    name: "Swift Dzire on Rent in Kharghar",
    description: "Swift Dzire on rent in Kharghar provides practical and budget-friendly travel for daily use and outstation trips. Professional drivers ensure safety. It guarantees a smooth experience."
  },
  {
    name: "Swift Dzire on Rent in Panvel",
    description: "Swift Dzire on rent in Panvel offers dependable transportation for local and long-distance travel. Comfortable interiors enhance travel experience. It ensures a hassle-free journey."
  }
],

tableData: [
  ["Swift Dzire on Rent in Mumbai", "Swift Dzire on Rent in Navi Mumbai"],
  ["Swift Dzire Rental Navi Mumbai", "Swift Dzire Hire in Navi Mumbai"],
  ["Swift Dzire Car Rental Navi Mumbai", "Swift Dzire Taxi Service Navi Mumbai"],
  ["Book Swift Dzire on Rent in Navi Mumbai", "Best Swift Dzire on Rent Navi Mumbai"],
  ["Cheapest Swift Dzire Rental Navi Mumbai", "Swift Dzire on Rent with Driver Navi Mumbai"],
  ["Swift Dzire Rental Service Navi Mumbai", "Swift Dzire Airport Pickup Navi Mumbai"],
  ["Swift Dzire Airport Drop Navi Mumbai", "Swift Dzire Outstation Rental Navi Mumbai"],
  ["Swift Dzire Cab for Outstation Navi Mumbai", "Swift Dzire on Rent in Vashi"],
  ["Swift Dzire on Rent in Nerul", "Swift Dzire on Rent in Kharghar"],
  ["Swift Dzire on Rent in Panvel", ""]
],


whychoose: [
  {
    WhyChooseheading: "Affordable Swift Dzire on Rent in Navi Mumbai",
    WhyChoosedescription: "Royal Route Cabs offers budget-friendly Swift Dzire rental in Navi Mumbai, ideal for daily travel, airport transfers, and outstation trips."
  },
  {
    WhyChooseheading: "Comfortable 4+1 Seater Sedan",
    WhyChoosedescription: "Swift Dzire provides comfortable seating for 4 passengers with good legroom and luggage space, perfect for small families and business travel."
  },
  {
    WhyChooseheading: "Low Per KM Pricing for Budget Travel",
    WhyChoosedescription: "Dzire rental starts from approximately ₹10 to ₹14 per km, making it one of the most economical cab options." 
  },
  {
    WhyChooseheading: "Affordable Local & Daily Packages",
    WhyChoosedescription: "Local rental packages start from ₹2300 to ₹3300 for 8–12 hours, depending on travel duration and plan." 
  },
  {
    WhyChooseheading: "Experienced & Professional Drivers",
    WhyChoosedescription: "Our drivers are trained and experienced in Navi Mumbai and highway routes, ensuring safe and smooth travel."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear pricing including driver allowance with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our Swift Dzire rental service in Navi Mumbai operates round the clock for all travel needs."
  },
  {
    WhyChooseheading: "Trusted Budget Sedan Rental Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by customers for reliable Dzire rental in Navi Mumbai with clean vehicles and punctual service."
  }
]

};

const faqData = [
  { question: "What is the price of Swift Dzire on rent in Navi Mumbai?", answer: "The price starts from ₹10–₹14 per km or ₹2300–₹3300 for local packages depending on duration." },
  { question: "How many passengers can travel in Swift Dzire?", answer: "Swift Dzire can comfortably seat 4 passengers with luggage space." },
  { question: "Is Dzire suitable for long-distance travel?", answer: "Yes, it is ideal for both city and outstation travel due to comfort and fuel efficiency." },
  { question: "Do you provide driver with rental?", answer: "Yes, all Swift Dzire rentals include professional drivers." },
  { question: "Is rental available 24 hours?", answer: "Yes, our service operates 24/7." },
  { question: "Can I book for airport pickup?", answer: "Yes, we provide Navi Mumbai and Mumbai airport pickup and drop services." },
  { question: "Do you provide one-way booking?", answer: "Yes, both one-way and round-trip options are available." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for better availability." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly." },
  { question: "What is included in rental fare?", answer: "Fare usually includes driver charges, while toll and parking may be extra depending on package." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Kunal Jadhav",
    feedback: "Swift Dzire on rent in Navi Mumbai with Royal Route Cabs was very convenient and budget-friendly. The car was clean and perfect for local travel.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Patil",
    feedback: "Good experience renting Swift Dzire in Navi Mumbai. The ride was smooth, the vehicle was well-maintained, and the service felt reliable and on time.",
    rating: 5
  }
];







  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Swift Dzire on Rent in Navi Mumbai",
  "image": "https://www.royalroutecabs.com/assets/images/swift-dzire-on-rent-navi-mumbai.jpg", // replace if needed
  "description": "Book Swift Dzire on rent in Navi Mumbai with Royal Route Cabs for affordable, comfortable, and fuel-efficient travel. Ideal for local trips, airport transfers, and outstation journeys with professional driver service available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "9/km", // indicative rate (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/swift-dzire-on-rent-in-navi-mumbai"
  }
};








  return (
    <div>

<Helmet>
  <title>Swift Dzire on Rent in Navi Mumbai | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Swift Dzire on rent in Navi Mumbai with Royal Route Cabs. Affordable sedan cab for airport, local, and outstation travel with 24x7 service and professional drivers."
  />

  <meta
    name="keywords"
    content="swift dzire on rent in mumbai, swift dzire on rent in navi mumbai, swift dzire rental navi mumbai, swift dzire hire in navi mumbai, swift dzire car rental navi mumbai, swift dzire taxi service navi mumbai, book swift dzire on rent in navi mumbai, best swift dzire on rent navi mumbai, cheapest swift dzire rental navi mumbai, swift dzire on rent with driver navi mumbai, swift dzire rental service navi mumbai, swift dzire airport pickup navi mumbai, swift dzire airport drop navi mumbai, swift dzire outstation rental navi mumbai, swift dzire cab for outstation navi mumbai, swift dzire on rent in vashi, swift dzire on rent in nerul, swift dzire on rent in kharghar, swift dzire on rent in panvel"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/85.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Swiftdzireonrentinnavimumbai;